import { NgModule } from "@angular/core";

import { ScrollToService } from "./scroll-to.service";

@NgModule({
  providers: [ScrollToService]
})
export class ScrollToModule {}
